import { render, staticRenderFns } from "./GoveSetting.vue?vue&type=template&id=25d368ea&scoped=true&"
import script from "./GoveSetting.vue?vue&type=script&lang=js&"
export * from "./GoveSetting.vue?vue&type=script&lang=js&"
import style0 from "./GoveSetting.vue?vue&type=style&index=0&id=25d368ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d368ea",
  null
  
)

export default component.exports